// @ts-nocheck
import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import PropTypes from 'prop-types';

const GroupWrapper = ({ children, label }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 0.5,
        padding: '0 4px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          padding: '0 4px',
        }}
      >
        {children}
      </Box>
      <Typography
        variant="caption"
        sx={{
          fontSize: '10px',
          color: theme?.palette?.primary?.main,
          textAlign: 'center',
          userSelect: 'none',
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

GroupWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
};

export default GroupWrapper;
